export default "__VITE_ASSET__29VNR3yC__"